import React, { Component } from 'react';
import './normalize.css';
import './App.css';
import tzclogo from './tzc_white.png';
import axios from 'axios';

export default class App extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            process: 0,
            bookingId: '',
            hotelName: 'Loading hotel data from Expedia, hold tight!',
            price: '',
            tzcPaid: 0,
            tzcPrice: '... loading Hotel Price in TZC',
            travelStart: '...Start Date ...',
            travelEnd: '... End Date ...',
            tzcAddress: '... loading TZC Address',
            error: '',

            bookingIdError: false,
            firstNameError: false,
            lastNameError: false,
            emailError: false,
            cellError: false,
        }

        this.getPageData = this.getPageData.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmitDetails = this.onSubmitDetails.bind(this);
        this.onSubmitRefresh = this.onSubmitRefresh.bind(this);
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    async onSubmit(e) {
        e.preventDefault();
        if (!e.target.value) {
            return;
        }
        if (e.target.value.length === 0) {
            this.setState({ bookingIdError: false });
            return;
        }

        let ebookingId = e.target.value;
        const regex = /([0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}&c=[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})/;
        ebookingId = ebookingId.match(regex);
        if (ebookingId === null) {
            this.setState({ bookingIdError: true });
            return;
        }
        ebookingId = ebookingId[0];
        this.setState({ bookingId: ebookingId });
        this.setState({ process: 1 });
        const pdata = await this.getPageData(ebookingId);
        
        // Hotel name has now loaded so let's finish displaying the second form correctly
        document.getElementById("firstNameInput").value='';
        document.getElementById("selHotelTextAbove").classList.add("visible");
        document.getElementById("bookingIdEntry").classList.add("visible");
        document.getElementById("selPrice").classList.add("visible");
        document.getElementById("dispPrice").classList.add("visible");

        // console.log(`RQ Result: ${JSON.stringify(pdata)}`);

        if (!pdata || pdata.error) {
            this.setState({ process: 0 });
            this.setState({ bookingIdError: true });
        }
    }

    async onSubmitDetails(e) {
        e.preventDefault();
        const sendData = {};
        const data = new FormData(e.target);
        sendData.bookingId = this.state.bookingId;
        sendData.firstName = data.get('firstName');
        sendData.lastName = data.get('lastName');
        sendData.email = data.get('email');
        sendData.cel = data.get('cellinput');

        let formError = false;
        if (sendData.firstName.length === 0) {
            this.setState({ firstNameError: true });
            formError = true;
        } else {
            this.setState({ firstNameError: false });
        }
        if (sendData.lastName.length === 0) {
            this.setState({ lastNameError: true });
            formError = true;
        } else {
            this.setState({ lastNameError: false });
        }
        if (sendData.email.length === 0) {
            this.setState({ emailError: true });
            formError = true;
        } else {
            this.setState({ emailError: false });
        }
        if (sendData.cel.length === 0) {
            this.setState({ cellError: true });
            formError = true;
        } else {
            this.setState({ cellError: false });
        }

        if (formError) {
            return;
        }


        try {
            await axios.post('https://trezartravels.com:3005/savePersonalInfos', sendData);
        } catch (e) {
            console.log(e);
            return;
        }

        this.setState({ process: 2 });
    }

    async onSubmitRefresh(e) {
        let response;
        try {
            response = await axios.post('https://trezartravels.com:3005/getPaymentInfo', { bookingId: this.state.bookingId });
        } catch (e) {
            console.log(e);
            return;
        }
        if (response.data) {
            if (response.data.coinsOnOrder >= this.state.tzcPrice) {
                this.setState({ process: 3 });
            }
            this.setState({ tzcPaid: response.data.coinsOnOrder });
        }
    }

    async getPageData(id) {
        // console.log(`Request for ${id}`);
        let response;
        try {
            response = await axios.post('https://trezartravels.com:3005/getInfo', { bookingId: id });
        } catch (e) {
            console.log(e);
            this.setState({ bookingIdError: true });
            this.setState({ process: 0 });
            return;
        }
        console.log(response.data.error);
        if (response.data.error) {
            this.setState({ error: response.data.error });
            return;
        }
        this.setState({ hotelName: response.data.hotelName });
        this.setState({ price: response.data.price });
        this.setState({ tzcPrice: response.data.tzcPrice });
        this.setState({ travelStart: response.data.travelStart });
        this.setState({ travelEnd: response.data.travelEnd });
        this.setState({ tzcAddress: response.data.tzcAddress });
        this.setState({ tzcPaid: response.data.coinsOnOrder });

        return response.data;
    }

    render() {
        if (this.state.process === 0) {
            // render help and search on main page load
            document.getElementById("lowerInfo").classList.add('visible');
            return this.firstForm();
        } else if (this.state.process === 1) {
            // remove lower help
            document.getElementById("lowerInfo").classList.remove('visible');
            return this.secondForm();
        } else if (this.state.process === 2) {
            return this.thirdForm();
        } else if (this.state.process === 3) {
            return this.finishForm();
        } 
    }

    firstForm() {
        return (
            <div className="section hero">
                <div className="container bgDiv" style={{marginTop: '50px'}}>
                    <div className="row">
                        <div className="one-full column center topper" style={{marginTop: '5%'}}>
                            <img src={tzclogo} style={{height: '50px'}} />
                                <h1>TrezarTravels</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center" style={{marginTop: '2%', color: 'antiquewhite'}}>
                            <h5>
                                Find, book, and pay for VIP+ Expedia hotels with your TrezarCoin
                                <br />
                            </h5>
                            <h6 style={{color: 'antiquewhite', marginTop: '-20px'}}>The best part? By paying with TrezarCoin, you get a 20% discount!</h6>
                        </div>
                    </div>

                    <div id="main" className="row" style={{marginTop: '15px'}}>
                        <div className="one-full column center" style={{display: 'block', margin: '0 auto', width: '100%', color:'black'}}>
                            <form id="bookingIdEntry" onSubmit={this.onSubmit}>
                                <input id="bookingIdInput" className={this.state.bookingIdError ? 'error hotelUrl' : 'hotelUrl'} onChange={this.onSubmit} type="text" name="bookingId" placeholder="Paste your Hotel Checkout URL here" />
                            </form>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center" >
                            <p id="infoText" className="one-full column center">Follow the steps below on how to use this site.<br /> Or read the following PDF guide: <a href="https://trezarcoin.com/TrezarTravels.pdf" target="_blank" rel="noopener noreferrer">click here</a></p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center">
                            <p id="errorText" className="one-full column center">{this.state.error}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    secondForm() {
        return (
            <div className="section hero">
                <div className="container bgDiv" style={{marginTop: '50px'}}>
                    <div className="row">
                        <div className="one-full column center topper" style={{marginTop: '5%'}}>
                            <img src={tzclogo} style={{height: '50px'}} />
                                <h1>TrezarTravels</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center" style={{marginTop: '2%', color: 'antiquewhite'}}>
                            <span className="hidden" id="selHotelTextAbove" style={{fontSize: '1.5rem', color: 'white'}}>Your selected hotel</span>
                            <h3>{this.state.hotelName}</h3>
                            <span className="hidden" id="selPrice" style={{fontSize: '1.5rem', color: 'white'}}>Price</span>
                            <h5 className="hidden" style={{fontFamily: 'arial'}} id="dispPrice" >{(this.state.price * 0.8).toFixed(2)}$ | {this.state.tzcPrice} TZC</h5>
                        </div>
                    </div>

                    <div id="main" className="row">
                        <div className="one-full column center" style={{display: 'block', margin: '0 auto', width: '100%', color:'black'}}>
                            <form id="bookingIdEntry" onSubmit={this.onSubmitDetails} className="hidden">
                                <input id="firstNameInput" className={this.state.firstNameError ? 'error hotelUrl' : 'hotelUrl'} type="text" name="firstName" placeholder="First Name" /><br />
                                <input id="lastNameInput" className={this.state.lastNameError ? 'error hotelUrl' : 'hotelUrl'} type="text" name="lastName" placeholder="Last Name" /><br />
                                <input id="emailInput" className={this.state.emailError ? 'error hotelUrl' : 'hotelUrl'} type="email" name="email" placeholder="E-Mail" /><br />
                                <input id="cellInput" className={this.state.cellError ? 'error hotelUrl' : 'hotelUrl'}  type="text" name="cellinput" placeholder="Cellphone Number" /><br />
                                <input id="submitDetails" type="submit" className="button button-primary hotelUrl" name="submitDetails" value="Place Order"  />
                            </form>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:'25px'}}>
                        <div id="infoText" className="one-full column center" style={{color: 'green', marginBottom: '5px'}}><h5 style={{fontWeight: '700'}}>Important tips to remember</h5></div>
                        <div id="infoText2" className="three columns">Check-in must be at least 3 days from the booking date</div>
                        <div id="infoText3" className="three columns">There are NO REFUNDS on orders made</div>
                        <div id="infoText4" className="three columns">Only VIP+ Expedia hotels qualify for this service</div>
                        <div id="infoText5" className="two columns">Valid booking information</div>
                    </div>
                    <div className="row">
                        <div className="one-full column center">
                            <p id="errorText" className="one-full column center">{this.state.error}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    thirdForm() {
        return (
            <div className="section hero">
                <div className="container bgDiv" style={{marginTop: '50px'}}>
                    <div className="row">
                        <div className="one-full column center topper" style={{marginTop: '5%'}}>
                            <img src={tzclogo} style={{height: '50px'}} />
                                <h1>TrezarTravels</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center" style={{marginTop: '2%', color: 'antiquewhite'}}>
                            <h5 style={{fontSize: '2rem', marginBottom: '-5px', color: 'white'}}>Your travel summary for</h5>
                            <h3 id="summaryHeading">{this.state.hotelName}</h3>
                        </div>
                    </div>

                    <div id="main" className="row">
                        <div className="one-full column center" style={{display: 'block', margin: '0 auto', width: '100%', color:'black'}}>
                            <table className="u-half-width bgFinal" style={{color: 'black', margin: '0 auto', marginTop: '10px', borderRadius: '5px'}}>
                                <tbody>
                                    <tr>
                                        <td style={{paddingTop: '30px'}}>
                                            <p className="summaryTextHead"><strong>Trip Duration</strong></p>
                                        </td>
                                        <td style={{paddingTop: '30px'}}>
                                            <p className="summaryText">{this.state.travelStart} - {this.state.travelEnd}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className="summaryTextHead"><strong>Travel Cost</strong></p>
                                        </td>
                                        <td>
                                            <p className="summaryText"><s>{this.state.price}$</s> {(this.state.price * 0.8).toFixed(2)}$ <span style={{ color: 'red' }}>(-20%)</span></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className="summaryTextHead"><strong>Price in TZC</strong></p>
                                        </td>
                                        <td>
                                            <p className="summaryText">{this.state.tzcPrice}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className="summaryTextHead"><strong>Payment Address</strong></p>
                                        </td>
                                        <td>
                                            <p className="summaryText">{this.state.tzcAddress}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p className="summaryTextHead"><strong>Amount Paid</strong></p>
                                        </td>
                                        <td>
                                            <p className="summaryText">{this.state.tzcPaid} / {this.state.tzcPrice} TZC</p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="one-full column center" style={{marginLeft: '0px', marginTop: '20px'}}><button className="button button-primary" onClick={this.onSubmitRefresh}>Refresh Payment</button></div>
                    </div>

                    <div className="row">
                        <div className="one-full column center" style={{marginTop: '2%', marginBottom: '2%', color: 'red'}}>
                            <span><strong><h4>Send your TrezarCoin to the payment address listed above. Click the Refresh button to check on the status!</h4></strong></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center">
                            <p id="errorText" className="one-full column center">{this.state.error}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    finishForm() {
        return (
            <div className="section hero">
                <div className="container bgDiv" style={{marginTop: '50px'}}>
                    <div className="row">
                        <div className="one-full column center topper" style={{marginTop: '5%'}}>
                            <img src={tzclogo} style={{height: '50px'}} />
                                <h1>TrezarTravels</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="one-full column center" style={{marginTop: '5%',marginBottom:'50px', color: 'antiquewhite'}}>
                            <img src={require("./accept-circle-512.png")} style={{height:'128px'}} alt='Success!' />
                            <h4><span style={{color:'green'}}>Success!</span> We have received your TrezarCoin payment.</h4>
                            <h4>You will receive a confirmation email within 24 hours.</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js